import { FC, ReactNode } from 'react';
import { Route, Routes } from 'react-router-dom';
import { DataConnectionContainer } from '../DataConnectionContainer';
import { DataConnectionData } from '../DataConnectionData';
export interface DataConnectionViewProps {
    placeholder?: ReactNode;
    callback?: any;
    env: string;
}

export const DataConnectionView: FC<DataConnectionViewProps> = ({ placeholder, callback, env }) => {
    return (
        <DataConnectionData>
            <DataConnectionContainer env={env}>
                <Routes>
                    <Route path="*" element={placeholder} />
                </Routes>
            </DataConnectionContainer>
        </DataConnectionData>
    );
};
